import React, { useState } from "react";
import { Button, Input } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const summaryData = [
  { label: "File", value: "KTKKAR0825" },
  { label: "FG", value: "Pushti" },
  { label: "Month", value: "May" },
  { label: "T.Mspcs", value: "80" },
  { label: "T.Qty", value: "10.60 T" },
  { label: "T.Benfi.", value: "3,91,230" }
];

const tableData = [
  { sno: 42, mspc: "MYSORE - SOUTH", totalBen: 9876, totalQty: "1.25 T", share: "15%" },
  { sno: 23, mspc: "BANGALORE - EAST", totalBen: 4567, totalQty: "2.50 T", share: "20%" },
  { sno: 34, mspc: "MANGALORE - WEST", totalBen: 3210, totalQty: "3.75 T", share: "25%" },
  { sno: 56, mspc: "HUBLI - CENTRAL", totalBen: 6543, totalQty: "4.00 T", share: "30%" },
  { sno: 78, mspc: "DAVANGERE - NORTH", totalBen: 7890, totalQty: "5.50 T", share: "35%" },
  { sno: 90, mspc: "SHIMOGA - SOUTH", totalBen: 1357, totalQty: "6.25 T", share: "40%" },
  { sno: 12, mspc: "KOLAR - EAST", totalBen: 2468, totalQty: "7.10 T", share: "45%" },
  { sno: 24, mspc: "KARWAR - WEST", totalBen: 3690, totalQty: "8.00 T", share: "50%" },
  { sno: 36, mspc: "TUMKUR - SOUTH", totalBen: 1470, totalQty: "9.50 T", share: "55%" },
];

const pillBoxStyle = {
  display: "inline-block",
  background: "#f4f6f8",
  borderRadius: "18px",
  padding: "4px 17px",
  marginRight: 12,
  fontWeight: 600,
  fontSize: 14,
  color: "#333",
  border: "1px solid #e0e0e0"
};

function exportCSV(data) {
  const headers = ["S.No", "MSPC", "Total Ben.", "Total Qty (T)", "Share %"];
  const rows = data.map(row => [
    row.sno,
    `"${row.mspc}"`,
    row.totalBen,
    row.totalQty,
    row.share
  ]);

  const csvContent = [headers, ...rows].map(e => e.join(",")).join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "pusthi_mspc_report.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

const PusthiMSPCReportScreen = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  const handleBack = () => {
    navigate("/master/raw-material-planning/details");
  };

  // 🔍 Filter data based on search text
  const filteredData = tableData.filter(row =>
    row.mspc.toLowerCase().includes(searchText.toLowerCase()) ||
    row.sno.toString().includes(searchText) ||
    row.totalBen.toString().includes(searchText)
  );

  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh" }}>
      {/* Header */}
      <div
        style={{
          width: "100%",
          background: "#1677ff",
          color: "#fff",
          fontWeight: 700,
          fontSize: 19,
          textAlign: "left",
          padding: "13px 28px",
          letterSpacing: ".2px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <span>View FG QTY - MSPC wise</span>
        <Button
          type="text"
          icon={<CloseOutlined style={{ fontSize: 21, color: "#fff" }} />}
          onClick={handleBack}
          style={{ minWidth: 36, minHeight: 36 }}
        />
      </div>

      <div
        style={{
          maxWidth: 1100,
          margin: "38px auto",
          background: "#fff",
          borderRadius: 18,
          boxShadow: "0 2px 8px #f0f1f2",
          padding: "34px 28px 30px 28px"
        }}
      >
        {/* Top Summary Boxes */}
        <div style={{ display: "flex", gap: 0, marginBottom: 20, flexWrap: "wrap" }}>
          {summaryData.map((item, idx) => (
            <div key={idx} style={pillBoxStyle}>
              {item.label}: <span style={{ fontWeight: 400 }}>{item.value}</span>
            </div>
          ))}
        </div>

        <h3 style={{ marginBottom: 13, fontWeight: 600, fontSize: 18 }}>Pusthi - May Month</h3>

        {/* Search + Actions */}
        <div style={{ display: "flex", gap: 14, marginBottom: 17 }}>
          <Input.Search
            placeholder="Search by MSPC or Ben ID"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{
              width: 270,
              borderRadius: 14,
              borderColor: "#e0e0e0"
            }}
            allowClear
          />
          <Button
            style={{
              borderRadius: 14,
              fontWeight: 500,
              background: "#f4f6f8",
              border: "1px solid #e0e0e0"
            }}
            onClick={() => exportCSV(filteredData)}
          >
            Download CSV
          </Button>
          <Button
            style={{
              borderRadius: 14,
              fontWeight: 500,
              background: "#f4f6f8",
              border: "1px solid #e0e0e0"
            }}
          >
            Print
          </Button>
        </div>

        {/* Table */}
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", borderRadius: 13, overflow: "hidden" }}>
            <thead>
              <tr style={{ background: "#f4f6f8", height: 42 }}>
                <th style={thStyle}>S.No</th>
                <th style={thStyle}>MSPC</th>
                <th style={thStyle}>Total Ben.</th>
                <th style={thStyle}>Total Qty (T)</th>
                <th style={thStyle}>Share %</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((row, idx) => (
                  <tr key={idx}>
                    <td style={tdStyle}>{row.sno}</td>
                    <td style={tdStyle}>{row.mspc}</td>
                    <td style={tdStyle}>{row.totalBen.toLocaleString()}</td>
                    <td style={tdStyle}>{row.totalQty}</td>
                    <td style={tdStyle}>{row.share}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center", padding: 20, color: "#999" }}>
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const thStyle = {
  padding: "10px",
  textAlign: "left",
  fontWeight: 600,
  fontSize: 14,
  borderBottom: "1px solid #e0e0e0"
};

const tdStyle = {
  padding: "10px",
  fontSize: 14,
  borderBottom: "1px solid #eee"
};

export default PusthiMSPCReportScreen;
